var moduleMap = {
	"./WorkspaceMgmtApp": () => {
		return Promise.all(/* __federation_expose_WorkspaceMgmtApp */[__webpack_require__.e(854), __webpack_require__.e(109)]).then(() => (() => ((__webpack_require__(83045)))));
	},
	"./WorkspaceMgmtRoutes": () => {
		return Promise.all(/* __federation_expose_WorkspaceMgmtRoutes */[__webpack_require__.e(539), __webpack_require__.e(826)]).then(() => (() => ((__webpack_require__(83844)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});